import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/context-state/AuthContext.jsx";
import SignInPage from "@/pages/auth/SignInPage.jsx";
import { MainLoader } from '@/components/loader/MainLoader.jsx'
import AuthLayout from '@/layouts/auth/index.jsx'
import { AUTH_RETURN_URL_KEY } from '@/consts/index.js'

export default function AuthGuard({ children }) {

    const { user, isInitialized } = useAuthContext()
    const { pathname, search } = useLocation()

    const [requestedLocation, setRequestedLocation] = useState(null);

    if (!isInitialized) {
        return <MainLoader className="main-surface bg-cover bg-center bg-no-repeat" />
    }

    if (!user) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        // Sign-in navigates to the account root, which would drop a deep link (e.g. a
        // shared creative). Stash it so AuthContext can send the user back after auth.
        if (pathname.startsWith('/account/') && search) {
            sessionStorage.setItem(AUTH_RETURN_URL_KEY, pathname + search)
        }
        return <AuthLayout><SignInPage /></AuthLayout>
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null)
        return <Navigate to={requestedLocation} />
    }

    return <> {children} </>
}
